import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Components/Home";
import Categories from "./Components/Categories";
import Products from "./Components/Products";
import ProductDetail from "./Components/ProductDetail";
import ContactUs from "./Components/ContactUs";
import AboutUs from "./Components/AboutUs";
import Cart from "./Components/Cart";
import Checkout from "./Components/Checkout";
import Success from "./Components/Success";
import { useCartStore } from "./store/cartStore";
import CreateProduct from "./Components/CreateProduct";
import Profile from "./Components/Profile";
import ChangePassword from "./Components/ChangePassword";
import ResetPassword from "./Components/ResetPassword";
import MyOrders from "./Components/MyOrders";
import AllOrders from "./Components/AllOrders";
import PrintInvoice from "./Components/PrintInvoice";
import AllProducts from "./Components/AllProducts";
import ReturnOrder from "./Components/ReturnOrder";
import ShippingPolicy from "./Components/ShippingPolicy";
import RefundPolicy from "./Components/RefundPolicy";
import TermsConditions from "./Components/TermsCondition";
import CancellationPolicy from "./Components/CancellationPolicy";
import PrivacyPolicy from "./Components/PrivacyPolicy";

function App() {
  const loadCart = useCartStore((state) => state.loadCart);

  // Load cart data only once
  useEffect(() => {
    loadCart();

    // 🔥 Wake up backend (preload API)
    fetch("https://legacy-decor-backend.onrender.com/categories")
      .then(() => {})
      .catch(() => {});
  }, []);
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/category/:id" element={<Products />} />
          <Route path="/products/:category?" element={<Products />} />
          <Route path="/products" element={<Products />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/success" element={<Success />} />
          <Route path="/createProduct" element={<CreateProduct />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/orders" element={<MyOrders />} />
          <Route path="/all-orders" element={<AllOrders />} />
          <Route path="/all-products" element={<AllProducts />} />
          <Route path="/admin/invoice/:orderId" element={<PrintInvoice />} />
          <Route path="/return-order/:orderId" element={<ReturnOrder />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
